import createValidator from 'revalidate/lib/createValidator';
import { INVALID_CHARACTER } from '../constants/defaultErrorMessages';
const onlyContainsValidCharacters = allowedCharacters => createValidator(message => input => {
  const regex = new RegExp(`^[${allowedCharacters}]*$`);
  return input && !regex.test(input) ? message : null;
}, INVALID_CHARACTER);
export default onlyContainsValidCharacters;